// projects/humanresources-personnel/src/assets/i18n/*/hr-per-identification.json
export class HrPerIdentificationKey {
    private static readonly keyPrefix = 'hrPerIdentification';
    public static title = `${HrPerIdentificationKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerIdentificationKey.keyPrefix}.pageHeader`;
    public static cardNumber = `${HrPerIdentificationKey.keyPrefix}.cardNumber`;
    public static placeOfIssue = `${HrPerIdentificationKey.keyPrefix}.placeOfIssue`;
    public static validityBeginDate = `${HrPerIdentificationKey.keyPrefix}.validityBeginDate`;
    public static validityEndDate = `${HrPerIdentificationKey.keyPrefix}.validityEndDate`;
    public static subtypeUuid = `${HrPerIdentificationKey.keyPrefix}.subtypeUuid`;
    public static socialSecuritySubtypeUuid = `${HrPerIdentificationKey.keyPrefix}.socialSecuritySubtypeUuid`;
}
